// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfluencerCards_influencer-container__cU7-\\+{
    display: flex;
    flex-flow: wrap;
    width: 83.3%;
    height: auto;
    margin: 3vw auto 5vw;
    justify-content: space-between;
    row-gap: 2.2vw;
}

.InfluencerCards_influencer-card__DqBOF{
    width: 26.1vw;
    height: 26.1vw;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 2vw;
    overflow: hidden;
}

.InfluencerCards_influencer-card-inner-container__CLTSO{
    position: absolute;
    z-index: 1;
}

.InfluencerCards_influencer-inner-name__mu\\+zb{
    margin-top: 2vw;
    margin-left: 2vw;
    margin-bottom: 0px;
    font-size: 2vw;
    color: white;
    font-family: dm-sans-light;
}

.InfluencerCards_influencer-img-container__aLUEt{
    display: flex;
    flex-direction: row;
    margin-top: 1vw;
    margin-left: 2vw;
}

.InfluencerCards_influencer-info__03Heh{
    display: inline;
    height: max-content;
    align-self: center;
    color: white;
    margin-left: 0.5vw;
}

.InfluencerCards_influencer-info-text__kNNz4{
    margin: 0px;
    font-size: 1.4vw;
    font-family: dm-sans-light;
}

.InfluencerCards_influencer-bg-img__zNnWB{
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.InfluencerCards_influencer-insta__0dzmA{
    display: inline;
    width: 4vw;
    height: 4vw;
}

.InfluencerCards_influencer-img__EcoiS{
    width: 25vw;
    height: 20vw;
    object-fit: contain;
    margin-top: -20vw;
    margin-left: 5vw;
}


@media(max-width: 768px){
    .InfluencerCards_influencer-container__cU7-\\+{
        display: flex;
        flex-flow: nowrap;
        width: 95vw;
        height: auto;
        margin-left: 5vw;
        margin-top: 3vw;
        margin-bottom: 5vw;
        transform: translateY(0%);
        overflow-x: scroll;
    }
    
    .InfluencerCards_influencer-card__DqBOF{
        min-width: 42vw;
        height: 42vw;
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 5vw;
        margin-right: 3vw;
        overflow: hidden;
    }
    
    .InfluencerCards_influencer-card-inner-container__CLTSO{
        position: absolute;
        z-index: 1;
    }
    
    .InfluencerCards_influencer-inner-name__mu\\+zb{
        margin-top: 5vw;
        margin-left: 2vw;
        margin-bottom: 0px;
        font-size: 4vw;
        color: white;
    }
    
    .InfluencerCards_influencer-img-container__aLUEt{
        display: flex;
        flex-direction: row;
        margin-top: 1vw;
        margin-left: 1vw;
    }
    
    .InfluencerCards_influencer-info__03Heh{
        display: inline;
        height: max-content;
        width: 40vw;
        align-self: center;
        color: white;
        margin-left: 0.2vw;
    }
    
    .InfluencerCards_influencer-info-text__kNNz4{
        margin: 0px;
        font-size: 3vw;
    }
    
    .InfluencerCards_influencer-bg-img__zNnWB{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .InfluencerCards_influencer-insta__0dzmA{
        display: inline;
        width: 9vw;
        height: 9vw;
    }
    
    .InfluencerCards_influencer-img__EcoiS{
        width: auto;
        height: auto;
        object-fit: cover;
        margin-top: -40vw;
        margin-left: 12vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/InfluencerCards.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,yBAAyB;QACzB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,qCAAqC;QACrC,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ","sourcesContent":[".influencer-container{\n    display: flex;\n    flex-flow: wrap;\n    width: 83.3%;\n    height: auto;\n    margin: 3vw auto 5vw;\n    justify-content: space-between;\n    row-gap: 2.2vw;\n}\n\n.influencer-card{\n    width: 26.1vw;\n    height: 26.1vw;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    border-radius: 2vw;\n    overflow: hidden;\n}\n\n.influencer-card-inner-container{\n    position: absolute;\n    z-index: 1;\n}\n\n.influencer-inner-name{\n    margin-top: 2vw;\n    margin-left: 2vw;\n    margin-bottom: 0px;\n    font-size: 2vw;\n    color: white;\n    font-family: dm-sans-light;\n}\n\n.influencer-img-container{\n    display: flex;\n    flex-direction: row;\n    margin-top: 1vw;\n    margin-left: 2vw;\n}\n\n.influencer-info{\n    display: inline;\n    height: max-content;\n    align-self: center;\n    color: white;\n    margin-left: 0.5vw;\n}\n\n.influencer-info-text{\n    margin: 0px;\n    font-size: 1.4vw;\n    font-family: dm-sans-light;\n}\n\n.influencer-bg-img{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.influencer-insta{\n    display: inline;\n    width: 4vw;\n    height: 4vw;\n}\n\n.influencer-img{\n    width: 25vw;\n    height: 20vw;\n    object-fit: contain;\n    margin-top: -20vw;\n    margin-left: 5vw;\n}\n\n\n@media(max-width: 768px){\n    .influencer-container{\n        display: flex;\n        flex-flow: nowrap;\n        width: 95vw;\n        height: auto;\n        margin-left: 5vw;\n        margin-top: 3vw;\n        margin-bottom: 5vw;\n        transform: translateY(0%);\n        overflow-x: scroll;\n    }\n    \n    .influencer-card{\n        min-width: 42vw;\n        height: 42vw;\n        border: 1px solid rgba(0, 0, 0, 0.12);\n        border-radius: 5vw;\n        margin-right: 3vw;\n        overflow: hidden;\n    }\n    \n    .influencer-card-inner-container{\n        position: absolute;\n        z-index: 1;\n    }\n    \n    .influencer-inner-name{\n        margin-top: 5vw;\n        margin-left: 2vw;\n        margin-bottom: 0px;\n        font-size: 4vw;\n        color: white;\n    }\n    \n    .influencer-img-container{\n        display: flex;\n        flex-direction: row;\n        margin-top: 1vw;\n        margin-left: 1vw;\n    }\n    \n    .influencer-info{\n        display: inline;\n        height: max-content;\n        width: 40vw;\n        align-self: center;\n        color: white;\n        margin-left: 0.2vw;\n    }\n    \n    .influencer-info-text{\n        margin: 0px;\n        font-size: 3vw;\n    }\n    \n    .influencer-bg-img{\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n    \n    .influencer-insta{\n        display: inline;\n        width: 9vw;\n        height: 9vw;\n    }\n    \n    .influencer-img{\n        width: auto;\n        height: auto;\n        object-fit: cover;\n        margin-top: -40vw;\n        margin-left: 12vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"influencer-container": `InfluencerCards_influencer-container__cU7-+`,
	"influencer-card": `InfluencerCards_influencer-card__DqBOF`,
	"influencer-card-inner-container": `InfluencerCards_influencer-card-inner-container__CLTSO`,
	"influencer-inner-name": `InfluencerCards_influencer-inner-name__mu+zb`,
	"influencer-img-container": `InfluencerCards_influencer-img-container__aLUEt`,
	"influencer-info": `InfluencerCards_influencer-info__03Heh`,
	"influencer-info-text": `InfluencerCards_influencer-info-text__kNNz4`,
	"influencer-bg-img": `InfluencerCards_influencer-bg-img__zNnWB`,
	"influencer-insta": `InfluencerCards_influencer-insta__0dzmA`,
	"influencer-img": `InfluencerCards_influencer-img__EcoiS`
};
export default ___CSS_LOADER_EXPORT___;
